import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Bell, Sparkles, TestTube, Crown, CalendarClock, Pill, HeartHandshake } from "lucide-react";

const ICONS = { diet_update: Sparkles, blood_reminder: TestTube, subscription: Crown, weekly_summary: CalendarClock, supplements: Pill, coach: HeartHandshake };

export const NotificationBell = () => {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);

  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data.notifications || []);
      setUnread(data.unread || 0);
    } catch (e) {}
  };
  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  return (
    <Popover onOpenChange={(open) => { if (open) load(); }}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="relative" data-testid="notif-bell" aria-label="Notifiche">
          <Bell className="h-5 w-5" />
          {unread > 0 && (
            <span className="absolute -top-0.5 -right-0.5 h-4 min-w-[16px] px-1 rounded-full bg-accent text-accent-foreground text-[10px] font-bold grid place-items-center"
              data-testid="notif-badge">{unread}</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0" data-testid="notif-panel">
        <div className="px-4 py-3 border-b font-medium text-sm">Notifiche</div>
        <div className="max-h-80 overflow-y-auto divide-y">
          {items.length === 0 && (
            <div className="px-4 py-8 text-center text-sm text-muted-foreground" data-testid="notif-empty">Nessuna notifica</div>
          )}
          {items.slice(0, 8).map((n) => {
            const Ic = ICONS[n.type] || Sparkles;
            return (
            <div key={n.notif_id} className="px-4 py-3 flex gap-3" data-testid={`notif-item-${n.notif_id}`}>
              <Ic className="h-4 w-4 text-primary shrink-0 mt-0.5" />
              <div className="min-w-0">
                <div className="text-sm font-medium">{n.title}</div>
                <p className="text-xs text-muted-foreground">{n.message}</p>
                <div className="text-[11px] text-muted-foreground mt-1 font-mono-data">{(n.created_at || "").slice(0, 16).replace("T", " ")}</div>
              </div>
            </div>
            );
          })}
        </div>
        <Link to="/notifications" className="block px-4 py-3 border-t text-sm text-center text-primary font-medium hover:bg-muted/50 transition-colors" data-testid="notif-see-all">
          Vedi tutte
        </Link>
      </PopoverContent>
    </Popover>
  );
};
